import { render, staticRenderFns } from "./SuperAdminCertUpload.vue?vue&type=template&id=a26b5b0e&scoped=true"
import script from "./SuperAdminCertUpload.vue?vue&type=script&lang=js"
export * from "./SuperAdminCertUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26b5b0e",
  null
  
)

export default component.exports